import React from 'react'
import styled from 'styled-components'
import { custom } from '../../context/customisationSettings'
// import { graphics } from '../graphics'

// const Radios = ({ children, selected, handleClick }) => {
const Radios = ({ data, dataIndex, parentIndex, handleClick, selected, selectedA, selectedB }) => {



  const ExtrasImage = ({ src }) => (
    <ImageWrap> <img src={src} /></ImageWrap>
  )

  return (

    <Wrap onClick={handleClick} $selected={selected}>
      <ExtrasImage src={graphics[data.image]} />

      {/* <input type="radio" name={data.optionGroup} id={data.option}  /> */}
      <label htmlFor={data.option}>{data.option} <span> £{data.price}</span></label>

    </Wrap>
  )
}

export default Radios

const Wrap = styled.div`
      display: flex;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      /* background: #55552f; */
      gap: 4px;
      border: ${(props) => (props.$selected ? '4px solid lime' : '4px solid transparent')};
      border-radius: 10px;
      padding-bottom: 8px;;
      
      
      
      & input {
        /* accent-color: var(--accent-btn-bg);
        scale: 1.7; */
        display: none;
      }
      
      & label {
        text-align: center;
        line-height: 1.2;
        
        & span {
          font-size: 0.95rem;
          padding-top: 0.4rem;
          line-height: 0.95rem;
          display: block;
        }
      }
      
      `
const ImageWrap = styled.div`
    background: white;
    border-radius: 6px;
    overflow: hidden;
    
    
    & img {
      width: 100%;
      aspect-ratio: 1;
      object-fit: contain;
    }  
    `